import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./App.css";
import { MovieModal } from "./components";
import {
  Landingpage,
  Signup,
  Login,
  Dashboard,
  Movieplayer,
  Upload,
  ForgotPassword,
  CategoryPage
} from "./pages";
import ProtectedRoute from "./pages/auth/ProtectedRoute";

function App() {
  return (
    <>
      <Router>
        <Route
          exact
          path="/"
          render={(props) => (
            <React.Fragment>
              <Landingpage />
            </React.Fragment>
          )}
        />
        <Route path="/movie/play/:id" component={Movieplayer} />
        <Route path="/moviemodal/:id" component={MovieModal} />
        <Route path="/login" component={Login} />
        <Route path="/signup" component={Signup} />
        <Route path="/categories" component={CategoryPage} />
        {/* <Route path="/Forgotpassword" component={Forgotpassword} /> */}
        {/* <Route path="/Resetpassword" component={Resetpassword} /> */}
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        {/* <Route path="/user-landing-page" component={Userlandingpage} /> */}
        <ProtectedRoute path="/upload" component={Upload} />
        <Route path="/forgot-password" component={ForgotPassword} />

        {/* <ProtectedRoutes path='/Userlandingpage' component={Userlandingpage} user={user}/> */}
      </Router>
    </>
  );
}

export default App;
